// import useState from "react-usestateref";
import React, { useEffect, useState } from "react";
import "./Header.css";
import AppBar from "@mui/material/AppBar";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { toast } from "react-hot-toast";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import logo from "../../assets/logo_header.webp";
import { RxCrossCircled } from "react-icons/rx";
import apiService from "../../core/Service/detail";
import { postMethod } from "../../core/service/common.api";
import * as web3 from "@solana/web3.js";
import { FiMenu } from "react-icons/fi";
import { AnimatePresence, motion } from "framer-motion";

import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";
import {
  useWeb3Modal,
  useDisconnect,
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers/react";

import { formatEther } from "ethers";
import { BrowserProvider } from "ethers";
import { IoIosCloseCircle } from "react-icons/io";
import warn_popup_img from "../../assets/disconnect_wallet.png";

import axios from "axios";
import { IoCloseCircleOutline } from "react-icons/io5";

const tokenPriceMap = {
  1: "ethereum", // ETH mainnet
  56: "binancecoin", // BNB mainnet
  137: "polygon", // Polygon
  97: "binancecoin", // BNB testnet (use mainnet price)
};

const drawerWidth = 240;

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sideBar, setSideBar] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const projectId = "0b8444fa79de9a3821c5410564de263f";

  const bscTestnet = {
    chainId: 0x61, // 97 in decimal
    name: "BSC Testnet",
    currency: "BNB",
    explorerUrl: "https://testnet.bscscan.com",
    rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545/",
  };

  const ethereum = {
    chainId: 0x1, // 1
    name: "Ethereum Mainnet",
    currency: "ETH",
    explorerUrl: "https://etherscan.io",
    rpcUrl: "https://eth.drpc.org", // you can use Infura/Alchemy too
  };

  const bnb = {
    chainId: 0x38, // 56
    name: "BNB Smart Chain",
    currency: "BNB",
    explorerUrl: "https://bscscan.com",
    rpcUrl: "https://bsc-dataseed.binance.org/",
  };

  const polygon = {
    chainId: 0x89, // 137
    name: "Polygon Mainnet",
    currency: "MATIC",
    explorerUrl: "https://polygonscan.com",
    rpcUrl: "https://polygon-rpc.com",
  };

  const chains = [bscTestnet, ethereum, bnb, polygon];

  const metadata = {
    name: "RWA Platform",
    description: "Multi-chain Wallet Connect",
    url: "https://yourapp.com",
    icons: ["https://yourapp.com/logo.png"],
  };

  const ethersConfig = defaultConfig({
    metadata,
    chains,
    projectId,
  });

  createWeb3Modal({
    ethersConfig,
    chains,
    projectId,
    defaultChain: bscTestnet,

    // ✅ Only show MetaMask + Trust Wallet
    includedWalletIds: [
      "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96", // MetaMask
      "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0", // Trust Wallet
    ],

    // ❌ No need for excludeWalletIds, allWallets, or enableWallets
    features: {
      email: false, // hides email login
      socials: false, // hides Google/Discord/etc.
    },
  });

  const { open, close } = useWeb3Modal();
  const { disconnect } = useDisconnect();
  const { walletProvider } = useWeb3ModalProvider();
  const navigate = useNavigate();

  const { isConnected, chainId } = useWeb3ModalAccount();

  const [preferredCurrency, setPreferredCurrency] = useState(
    localStorage.getItem("preferredCurrency") || "usd"
  );

  useEffect(() => {
    localStorage.setItem("preferredCurrency", preferredCurrency);
  }, [preferredCurrency]);

  useEffect(() => {
    if (isConnected && walletProvider) {
      // ✅ Handle chain change
      walletProvider.on("chainChanged", async () => {
        console.log("Chain changed, updating balance...");
        await getbalanceaddress();
      });

      // ✅ Handle account change
      walletProvider.on("accountsChanged", async () => {
        console.log("Account changed, updating balance...");
        await getbalanceaddress();
      });

      // ✅ Cleanup on unmount
      return () => {
        walletProvider.removeAllListeners("chainChanged");
        walletProvider.removeAllListeners("accountsChanged");
      };
    }
  }, [isConnected, walletProvider]);

  useEffect(() => {
    const storedAddress = localStorage.getItem("userAddress");
    if (storedAddress) {
      setAddress(storedAddress);
    }
  }, []);

  // const [address, setAddress, addressref] = useState("");
  const [address, setAddress] = useState("");
  const [balance, setBalance] = useState(0);
  const [usdBalance, setUsdBalance] = useState(0);
  const [walletType, setWalletType] = useState(0);

  const getbalanceaddress = async () => {
    try {
      if (!isConnected) throw Error("User disconnected");

      const provider = new BrowserProvider(walletProvider);
      const signer = await provider.getSigner();
      const userAddress = await signer.getAddress();

      setAddress(userAddress);
      localStorage.setItem("userAddress", userAddress);
      setWalletType("Metamask");
      localStorage.setItem("WalletType", "Metamask");

      const balanceWei = await provider.getBalance(userAddress);
      const nativeBalance = formatEther(balanceWei);
      setBalance(nativeBalance);
      localStorage.setItem("balance", nativeBalance);

      // ✅ Get USD conversion
      const coinId = tokenPriceMap[chainId] || "ethereum"; // fallback ETH
      const { data } = await axios.get(
        `https://api.coingecko.com/api/v3/simple/price?ids=${coinId}&vs_currencies=usd`
      );
      connectwallet(userAddress, coinId);
      console.log(data, "Datas");
      const usdPrice = data[coinId].usd;
      const balanceInUSD = (parseFloat(nativeBalance) * usdPrice).toFixed(2);
      localStorage.setItem("balanceUSD", balanceInUSD);
      setUsdBalance(balanceInUSD);
      toast.success("Wallet Connected");
      navigate("/dashboard");
    } catch (error) {
      console.error("Balance fetch error:", error);
    }
  };
    const showsuccessToast = (message) => {
          toast.dismiss();
          toast.success(message);
      };
  
      const showerrorToast = (message) => {
          toast.dismiss();
          toast.error(message);
      };
  const connectwalletToast=()=>{
      showerrorToast("Connect wallet");
  }

  useEffect(() => {
    if (isConnected) {
      const Useradd = localStorage.getItem("userAddress");
      const WalletType = localStorage.getItem("WalletType");
      localStorage.setItem("", "");
      if (!Useradd) {
        if (WalletType != "solflareWallet") {
          getbalanceaddress();
        }
      }
    }
  }, [isConnected]);

  const connectwallet = async (walletAddress, chain) => {
    try {
      var loginHisObj = {
        walletAddress,
        chain,
      };
      var data = {
        apiUrl: apiService.connectwallet,
        payload: loginHisObj,
      };
      var resp = await postMethod(data);
      if (resp.status == true) {
      } else {
      }
    } catch (err) {
      console.log(err, "=-==-");
    }
  };

  const handleWalletConnect = async () => {
    await open();
  };

  const disconnectWallet = async () => {
    try {
      const WalletType = localStorage.getItem("WalletType");
      if (WalletType == "solflareWallet") {
        const provider = window.solflare;
        await provider.disconnect();
      } else {
        await disconnect();
      }
      setAddress("");
      localStorage.clear();
      toast.success("Wallet Disconnected");
      navigate("/");
    } catch (error) {
      console.log(error, "error diccon");
    }
  };

  const connectSolflareWallet = async () => {
    try {
      const provider = window.solflare;
      if (!provider) {
        alert(
          "Solflare wallet not found. Please add extension and create wallet."
        );
        window.open("https://solflare.com/", "_blank");
        return;
      }

      if (!provider.connected) await provider.connect();

      const walletKey = provider.publicKey.toBase58();
      setWalletType("solflareWallet");
      localStorage.setItem("WalletType", "solflareWallet");
      setAddress(walletKey);
      localStorage.setItem("userAddress", walletKey);
      await fetchSolBalance(walletKey);
      connectwallet(walletKey, "102");

      toast.success("Wallet Connected");
      navigate("/dashboard");
    } catch (error) {}
  };

  const fetchSolBalance = async (address) => {
    try {
      const connection = new web3.Connection("https://api.devnet.solana.com");
      const walletKey = new web3.PublicKey(address);
      const balance = await connection.getBalance(walletKey);
      const nativeBalance = balance / web3.LAMPORTS_PER_SOL;
      localStorage.setItem("balance", nativeBalance);
      const { data } = await axios.get(
        `https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd`
      );
      const usdPrice = data["solana"].usd;
      const balanceInUSD = (parseFloat(nativeBalance) * usdPrice).toFixed(2);
      localStorage.setItem("balanceUSD", balanceInUSD);
    } catch (error) {}
  };

  const nav_dashboard = () => {
    navigate("/dashboard");
  };

  const drawer = (
    <div
      onClick={handleDrawerToggle}
      className="drawe_side_main"
      sx={{ textAlign: "center" }}
    >
      <Link to={"/"} className="logo_img_div">
        <img src={logo} alt="logo" />
      </Link>

      {address != "" ? (
        <>
          <ul className="drawer_menus">
            <li>
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li>
              <Link to="/profile">Profile</Link>
            </li>
            <li>
              <Link to="/market">Market</Link>
            </li>
            <li>
              <Link to="/portfolio">Portfolio</Link>
            </li>
          </ul>
        </>
      ) : (
        <>
          <ul className="drawer_menus">
            <li>
              <Link>Marketplace</Link>
            </li>
            <li>
              <Link to="/institution">For Institutions</Link>
            </li>
            <li>
              <Link to="/aboutUs">About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact us</Link>
            </li>
          </ul>
        </>
      )}
      {address == "" ? (
        <>
          <button
            className="primary_btn drawer_header_btn"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            Tokenize Now
          </button>

          <button className="primary_btn drawer_header_btn">
            <Link to={"/login"}>Admin</Link>
          </button>
        </>
      ) : (
        <>
          {/* <button className="primary_btn drawer_header_btn" onClick={nav_dashboard}>Tokenize Now</button> */}

          <button
            className="primary_btn header_btn"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal1"
          >
            {" "}
            {address.substring(0, 10)}...{" "}
          </button>
        </>
      )}
    </div>
  );

  return (
    <>
      <div sx={{ display: "flex" }} className="header_wrp">
        {/* <CssBaseline /> */}
        <AppBar component="nav" className="header_nav">
          <Toolbar className="nav_toolbar">
            <div className="nav_main">
              <div className="nav_menus_wrp">
                <Link to={"/"} className="logo_img_div">
                  <img src={logo} alt="logo" />
                </Link>

                <ul className="navbar">
                  <li className="navbar_items dropdown">
                    <Link
                      className="dropdown-toggle"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Marketplace <IoIosArrowDown className="navitem_icon" />
                    </Link>
                    <ul
                      className="dropdown-menu dropdown_body"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <div className="drop_left">
                        <h2>Market Place</h2>
                        <p>
                          “Discover, trade, and invest in tokenized real-world
                          assets through a secure, transparent, and liquid
                          marketplace.”
                        </p>
                      </div>
                      <div className="drop_rgt">
      {address != "" ? (

                       <>
                        <li>
                          <Link
                            to={"/dashboard"}
                            className="dropdown-item"
                            href="#"
                          >
                            Dashboard
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={"/profile"}
                            className="dropdown-item"
                            href="#"
                          >
                            Profile
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={"/market"}
                            className="dropdown-item"
                            href="#"
                          >
                            Market
                          </Link>
                        </li></>):<>
                         <li onClick={connectwalletToast}>
                          <Link
                            className="dropdown-item"
                            href="#"
                          >
                            Dashboard
                          </Link>
                        </li>
                        <li onClick={connectwalletToast}>
                          <Link
                            className="dropdown-item"
                            href="#"
                          >
                            Profile
                          </Link>
                        </li>
                        <li onClick={connectwalletToast}>
                          <Link
                            className="dropdown-item"
                            href="#"
                          >
                            Market
                          </Link>
                        </li></>}
                        {/* <li>
                        <Link to={""} className="dropdown-item" href="#">
                          Staking
                        </Link>
                      </li>
                      <li>
                        <Link to={""} className="dropdown-item" href="#">
                          Liquidity Pool
                        </Link>
                      </li> */}
                      </div>
                    </ul>
                  </li>
                  <li className="navbar_items">
                    <Link to="/institution">
                      For Institutions{" "}
                      <FaArrowUpRightFromSquare className="navitem_icon_inst" />
                    </Link>
                  </li>
                  <li className="navbar_items">
                    <Link to={"/aboutUs"}>About Us</Link>
                  </li>

                  <li className="navbar_items">
                    <Link to={"/contact"}>Contact us</Link>
                  </li>
                </ul>

                <div className="header_btn_main">
                  {address == "" ? (
                    <button
                      className="primary_btn header_btn"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      Tokenize Now
                    </button>
                  ) : (
                    <>
                      <button
                        className="primary_btn header_btn"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal1"
                      >
                        {" "}
                        {address.substring(0, 10)}...{" "}
                      </button>
                      {/* <button
                    className="primary_btn header_btn"
                    onClick={() => switchNetwork(1)}
                  >
                    {" "}
                    ETH{" "}
                  </button>
                  <button
                    className="primary_btn header_btn"
                    onClick={() => switchNetwork(56)}
                  >
                    {" "}
                    BNB{" "}
                  </button>
                  {addressref.current !== "" && (
                    <span className="wallet_balance">
                      {parseFloat(balance).toFixed(4)}
                    </span>
                  )} */}
                    </>
                  )}

                  {address ? (
                    ""
                  ) : (
                    <button className="primary_btn header_btn_signin">
                      <Link to={"/login"}>Admin </Link>
                    </button>
                  )}
                </div>
              </div>

              {/* <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { lg: "none" } }}
              className="mobile_toggle"
            >
              <MenuIcon />
            </IconButton> */}

              <div className="mobile_toggle">
                <button
                  className="mobile_toggle_btn"
                  onClick={() => setSideBar(true)}
                >
                  <FiMenu />
                </button>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        {/* <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav> */}

        <>
          <div
            className="modal fade disConnect_popup"
            id="exampleModal1"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content wallet_modal_content">
                <div className="wallet_modal_head disconect_modal_head">
                  <span className="close_icon_disc" data-bs-dismiss="modal">
                    <IoIosCloseCircle />
                  </span>
                  <img
                    className="warn_popup_img"
                    src={warn_popup_img}
                    alt="warn_popup_img"
                  />
                  <h4>You’re about to disconnect your wallet from Assetly.</h4>
                  <p>
                    This action will log you out of your portfolio and trading
                    features, but your funds remain safe in your wallet.
                  </p>
                </div>
                <div className="discnt_popup_btnwrp">
                  <button className="cancel" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button
                    className="disconnect"
                    data-bs-dismiss="modal"
                    onClick={disconnectWallet}
                  >
                    Disconnect
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>

        <>
          <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content wallet_modal_content">
                <div className="wallet_modal_head">
                  <h4>
                    Select Your Wallet{" "}
                    <span>
                      <RxCrossCircled data-bs-dismiss="modal" />
                    </span>
                  </h4>
                  <p>
                    Connect your wallet to access your personalized dashboard
                    instantly.
                  </p>
                </div>
                <div className="wallet_modal_body">
                  <div
                    className="wlt_md_flx_outer"
                    onClick={() => handleWalletConnect()}
                    data-bs-dismiss="modal"
                  >
                    <div className="wlt_md_flx">
                      <img
                        src={
                          new URL(
                            "../../assets/wallet_connect.webp",
                            import.meta.url
                          )
                        }
                        alt=""
                        className="wlt_md_icon"
                      />
                      <span>Wallet Connect</span>
                    </div>
                  </div>

                  <div
                    className="wlt_md_flx_outer"
                    onClick={() => connectSolflareWallet()}
                    data-bs-dismiss="modal"
                  >
                    <div className="wlt_md_flx">
                      <img
                        src={new URL("../../assets/solf.png", import.meta.url)}
                        alt=""
                        className="wlt_md_icon"
                      />
                      <span>Solflare Wallet</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>

      {/* Mobile Drawer */}
      <AnimatePresence>
        {sideBar && (
          <>
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", bounce: 0, duration: 0.4 }}
              className="drawer_sidebar"
            >
              <div className="drawer_top">
                <a href="/" className="mobile_logo_wrap">
                  <img src={logo} alt="Assetly logo" />
                </a>
                <button
                  onClick={() => setSideBar(false)}
                  className="drawer_close_btn"
                >
                  <IoCloseCircleOutline />
                </button>
              </div>

              {address != "" ? (
                <>
                  <ul className="drawer_menus">
                    <li>
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li>
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li>
                      <Link to="/market">Market</Link>
                    </li>
                    <li>
                      <Link to="/portfolio">Portfolio</Link>
                    </li>
                  </ul>
                </>
              ) : (
                <>
                  <ul className="drawer_menus">
                    <li>
                      <Link>Marketplace</Link>
                    </li>
                    <li>
                      <Link to="/institution">For Institutions</Link>
                    </li>
                    <li>
                      <Link to="/aboutUs">About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact us</Link>
                    </li>
                  </ul>
                </>
              )}
              {address == "" ? (
                <>
                  <button
                    className="primary_btn drawer_header_btn d-block"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    Tokenize Now
                  </button>

                  <button className="primary_btn drawer_header_btn d-block">
                    <Link to={"/login"}>Admin</Link>
                  </button>
                </>
              ) : (
                <>
                  {/* <button className="primary_btn drawer_header_btn" onClick={nav_dashboard}>Tokenize Now</button> */}

                  <button
                    className="primary_btn header_btn"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal1"
                  >
                    {" "}
                    {address.substring(0, 10)}...{" "}
                  </button>
                </>
              )}
            </motion.div>

            {/* Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={() => setSideBar(false)}
              className="drawer_overlay"
            />
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
